import { Box } from "@mui/material";

interface StoreIconProps {
  size?: number;
}

/** Apple, Google Play and Instagram marks used by the store links. */
export const AppleIcon = ({ size = 22 }: StoreIconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M17.05 12.9c-.03-2.6 2.13-3.85 2.22-3.9-1.21-1.77-3.1-2.02-3.77-2.05-1.6-.16-3.13.94-3.94.94-.82 0-2.07-.92-3.4-.9-1.75.03-3.37 1.02-4.27 2.58-1.82 3.16-.47 7.83 1.3 10.4.86 1.25 1.89 2.66 3.24 2.61 1.3-.05 1.79-.84 3.36-.84 1.56 0 2 .84 3.37.81 1.39-.02 2.27-1.28 3.12-2.54.98-1.45 1.39-2.85 1.41-2.92-.03-.01-2.71-1.04-2.74-4.13z" />
    <path d="M14.9 5.4c.72-.87 1.2-2.07 1.07-3.27-1.03.04-2.28.69-3.02 1.55-.66.77-1.24 2-.1 3.14 1.12.09 2.26-.55 2.98-1.42z" />
  </Box>
);

export const PlayIcon = ({ size = 20 }: StoreIconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M3 3.4v17.2c0 .6.7 1 1.2.6l13.6-8.6c.5-.3.5-1 0-1.3L4.2 2.8C3.7 2.5 3 2.8 3 3.4z" />
  </Box>
);

export const InstagramIcon = ({ size = 18 }: StoreIconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    aria-hidden="true"
  >
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </Box>
);
